import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const usePackageCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      height: '100%',
      padding: 0,
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: 'none',
      transition: 'all 0.3',
      borderRadius: theme.shape.borderRadius,
      '& .continue-btn': {
        background: theme.palette.common.white
      },
      '&:hover': {
        background: theme.palette.common.white,
        '& .continue-btn': {
          background: theme.palette.primary.main,
          color: theme.palette.common.white
        }
      },
      '& .MuiListItemText-primary': {
        marginBottom: 0
      },
      '& .MuiListItemIcon-root': {
        minWidth: 30
      }
    },
    actionArea: {
      height: '100%',
      display: 'flex',
      alignItems: 'stretch',
      padding: theme.spacing(3),
      '&:hover': {
        background: theme.palette.common.white
      },
      '& .MuiCardActionArea-focusHighlight': {
        opacity: `0 !important`
      }
    },
    popular: {
      position: 'absolute',
      width: 118,
      height: 30,
      top: -15,
      left: 0,
      right: 0,
      margin: '0 auto',
      zIndex: 120,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '20px',
      color: theme.palette.common.white
    }
  })
)
